import styled from 'styled-components';

import Colours from '/shared/styled/Colours';

export const StyledMultiStepRadioGroup = styled.div`
  display: flex;
  max-width: 40rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
`;

export const StyledMultiStepSection = styled.section`
  margin-bottom: 2rem;
`;

export const StyledMultiStepSummaryCard = styled.section`
  border: 1px solid ${Colours.greyLight4};
  border-radius: 0.25rem;
  padding: 1rem 1.5rem;
  margin-bottom: 2rem;
  max-width: 49rem;
  /* background: ${Colours.white}; */
`;

export const StyledMultiStepSummaryHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid ${Colours.greyLight2};
  margin-bottom: 1rem;
  padding: 0.5rem 0;
`;

export const StyledMultiStepSummaryTitle = styled.div`
  font-size: 1.1rem;
  width: 100%;
`;

export const StyledMultiStepSummaryButtons = styled.div`
  margin-bottom: 2rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const StyledMultiStepSummaryBody = styled.div`
  display: table;
  line-height: 1.5;
  width: 100%;
`;

export const StyledMultiStepSummaryForm = styled.div`
  margin: 1rem 0;
  border: 1px solid ${Colours.greyLight6};
  padding: 1rem 3rem;
  background: ${Colours.whiteDark1};
`;

export const StyledMultiStepSummaryItem = styled.div`
  display: table-row;

  > * {
    display: table-cell;
    padding: 0.5rem 0;
    width: 50%;
  }

  > *:first-child {
    padding-right: 4rem;
  }

  > *:last-child {
    font-weight: 500;
    text-align: right;
  }
`;
